import { ApplicationState } from "@/main/store";
import { useSelector } from "react-redux";

export const useFileTypeReducer = () => useSelector((state: ApplicationState) => state.fileType);
